/**
 * @generated SignedSource<<35fe56195fc8754dcd89ea9a4f77d620>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type countryFragment$data = {
  readonly name: string;
  readonly isoCodeTwo: string;
  readonly isoCodeThree: string;
  readonly continentName: string;
  readonly currency: string | null;
  readonly currencySymbol: string | null;
  readonly " $fragmentType": "countryFragment";
};
export type countryFragment$key = {
  readonly " $data"?: countryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"countryFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "countryFragment"
};

(node as any).hash = "91b5ddcf66b8dadb05a72f6373866504";

export default node;
